export const formatDate = (locale: string, date: Date): string =>
  date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

export const formatTime = (locale: string, d: string): string =>
  new Date(d).toLocaleTimeString(locale, {
    hour: 'numeric',
    hour12: false,
    minute: '2-digit',
  });
